import { render } from "./PhysicalNetworksTab.vue?vue&type=template&id=f067a700&scoped=true"
import script from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"
export * from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"

import "./PhysicalNetworksTab.vue?vue&type=style&index=0&id=f067a700&lang=scss&scoped=true"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f067a700"]])

export default __exports__